import { DisablableOption, ModelBase } from "@models";
import { APIClass } from "@utilities/smart_api_class";

export interface Language extends ModelBase {
  data_type: "language";
  _id: string;
  name: string;
  description: string;
  type: "Common" | "Exotic" | "Specific" | "Special"; // = "Common"; 
  script: string; // = "";
  typical_speakers: string[]; // = [];

  // get language_type() {
  //   return this.type;
  // }

  // constructor(obj?: any) {
  //   super(obj);
  //   if (obj) {
  //     this.type = obj.type ? obj.type : "Common";
  //     this.script = obj.script ? `${obj.script}` : "";
  //     this.typical_speakers = obj.typical_speakers ? obj.typical_speakers : [];
  //   }
  // }

  // toDBObj(): any {
  //   const base_db_obj = super.toDBObj();
  //   return {
  //     ...base_db_obj,
  //     type: this.type,
  //     script: this.script,
  //     typical_speakers: this.typical_speakers
  //   };
  // }

  // copy(copyMe: Language, drop_ids: boolean = false): void {
  //   super.copy(copyMe, drop_ids);
  //   this.type = copyMe.type;
  //   this.script = copyMe.script;
  //   this.typical_speakers = copyMe.typical_speakers;
  // }

  // clone(drop_ids: boolean = false): Language {
  //   const new_obj = new Language();
  //   new_obj.copy(this, drop_ids);
  //   return new_obj;
  // }

  // copy5e(copyMe: any): void {
  //   console.log(copyMe);
  //   this.name = copyMe.name;
  //   this.description = copyMe.desc;
  //   this.type = copyMe.type;
  //   this.script = copyMe.script;
  //   this.typical_speakers = copyMe.typical_speakers;
  // }
}

export const LANGUAGES: Language[] = [{
  data_type: "language",
  _id: "5fd2abdf2ac19f2234327b1b",
  name: "Thieves' Cant",
  description: "This is a special code which can be inserted into regular speech to allow those who speak it to communicate messages to each other without others understanding what is being said.",
  type: "Special",
  script: "No written form",
  typical_speakers: ["Rogues"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Thieves' Cant",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "SKIN_CANT_CHANGELINGS_ONLY",
  name: "Skin Cant",
  description: "As a Changeling Traveler, you learn a secret language that allows you to silently convey messages to fellow changelings. This is a rare language that can only be “spoken” by shapechangers, though other creatures can learn to understand it. Skin Cant uses shifting patterns of scars, tattoos, and pigment. This allows you to convey a short message—a concept that can be expressed in six words or less—to anyone who knows the language and who can see you. Typically the message is something you maintain as part of your appearance; for example, in crafting your image, you might add a pattern of scars that tells other changeling travelers, “I need help” or “Everything I say is a lie.” You can also use this language to have a conversation—typically by manifesting symbols on the palm of your hand—with someone who is within 60 feet and able to see you. The shifting patterns can be noticed by other observers within 60 feet; if you wish to keep the conversation discrete, you can hide it with a Charisma (Deception) check opposed by the observer’s Wisdom (Perception or Insight) check. If you fail, it means the observer notices your shifting patterns, though they don’t understand the meaning unless they also know Skin Cant.",
  type: "Special",
  script: "No written form",
  typical_speakers: ["Changeling Travelers"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Skin Cant",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5ffe91202117e909180d2322",
  name: "Common",
  description: "",
  type: "Common",
  script: "Common",
  typical_speakers: ["Humans"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Common",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5ffe91282117e909180d2323",
  name: "Draconic",
  description: "Draconic is thought to be one of the oldest languages and is often used in the study of magic. The language sounds harsh to most other creatures and includes numerous hard consonants and sibilants.",
  type: "Common",
  script: "Draconic",
  typical_speakers: ["Dragons", " Dragonborn"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Draconic",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff291ce64454252445d747",
  name: "Abyssal",
  description: "",
  type: "Exotic",
  script: "Infernal",
  typical_speakers: ["Demons"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Abyssal",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff291ce64454252445d748",
  name: "Celestial",
  description: "",
  type: "Exotic",
  script: "Celestial",
  typical_speakers: ["Celestials"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Celestial",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff291de64454252445d749",
  name: "Deep Speech",
  description: "",
  type: "Exotic",
  script: "",
  typical_speakers: ["Aboleths", "Cloakers"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Deep Speech",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff291ee64454252445d74a",
  name: "Dwarvish",
  description: "Dwarvish is full of hard consonants and guttural sounds.",
  type: "Common",
  script: "Dwarvish",
  typical_speakers: ["Dwarves"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Dwarvish",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff291fe64454252445d74b",
  name: "Elvish",
  description: "Elvish is fluid, with subtle intonations and intricate grammar. Elven literature is rich and varied, and their songs and poems are famous among other races. Many bards learn their language so they can add Elvish ballads to their repertoires.",
  type: "Common",
  script: "Elvish",
  typical_speakers: ["Elves"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Elvish",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2920e64454252445d74c",
  name: "Giant",
  description: "",
  type: "Common",
  script: "Dwarvish",
  typical_speakers: ["Ogres", "Giants"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Giant",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2921e64454252445d74d",
  name: "Gnomish",
  description: "The Gnomish language, which uses the Dwarvish script, is renowned for its technical treatises and its catalogs of knowledge about the natural world.",
  type: "Common",
  script: "Dwarvish",
  typical_speakers: ["Gnomes"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Gnomish",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2921e64454252445d74e",
  name: "Goblin",
  description: "",
  type: "Common",
  script: "Dwarvish",
  typical_speakers: ["Goblinoids"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Goblin",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2922e64454252445d74f",
  name: "Halfling",
  description: "The Halfling language isn't secret, but halflings are loath to share it with others. They write very little, so they don't have a rich body of literature. Their oral tradition, however, is very strong.",
  type: "Common",
  script: "Common",
  typical_speakers: ["Halflings"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Halfling",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2923e64454252445d750",
  name: "Infernal",
  description: "",
  type: "Exotic",
  script: "Infernal",
  typical_speakers: ["Devils"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Infernal",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2924e64454252445d751",
  name: "Orc",
  description: "Orc is a harsh, grating language with hard consonants. It has no script of its own but is written in the Dwarvish script.",
  type: "Common",
  script: "Dwarvish",
  typical_speakers: ["Orcs"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Orc",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2925e64454252445d752",
  name: "Primordial",
  description: "",
  type: "Exotic",
  script: "Dwarvish",
  typical_speakers: ["Elementals"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Primordial",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2926e64454252445d753",
  name: "Sylvan",
  description: "",
  type: "Exotic",
  script: "Elvish",
  typical_speakers: ["Fey creatures"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Sylvan",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "5fff2926e64454252445d754",
  name: "Undercommon",
  description: "",
  type: "Exotic",
  script: "Elvish",
  typical_speakers: ["Underdark traders"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Undercommon",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "608c5c6cc656ea1c80ac9470",
  name: "Druidic",
  description: "",
  type: "Special",
  script: "",
  typical_speakers: ["Druids"],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Druidic",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "6314e53714531d0009a655f1",
  name: "Common Sign Language",
  description: "",
  type: "Special",
  script: "",
  typical_speakers: [],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Common Sign Language",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "6716fefdd2b3870f175e06a2",
  name: "Beast Speech",
  description: "This represents the magical ability to speak with animals.",
  type: "Specific",
  script: "",
  typical_speakers: [],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Beast Speech",
  tag_string: "", free: false
}, {
  data_type: "language",
  _id: "6717050c15616b664e8c0565",
  name: "Plant Speech",
  description: "This represents the magical ability to speak with Plants, as granted by the Speak with Plants spell.",
  type: "Specific",
  script: "",
  typical_speakers: [],
  image_url: "",
  archived: false,
  variant_group_id: "",
  variant_group: [],
  variant_ids: [],
  is_dominant: true,
  getCoreDominanceLevel: () => { return 0; }, getNonCoreDominanceLevel: () => { return 0; }, isCore: () => { return true; }, thisIsCore: () => { return true; }, isNonVersionVariant: () => { return false; }, getDominant: () => { return new ModelBase(); }, isDominant: () => { return true; }, detailFormat: () => { return ""; },
  source_book_ids: [],
  source_book_abbrev: "",
  notes: "",
  source_books: [], source_books_old: [], ua: false, blocked: false, hb: false, tp: false,
  owner_id: "",
  variant_of_id: "",
  // non_version_variant: false,
  // use_base_name: false,
  monster: false,
  template_only: false,
  reusable_string_ids: [],
  open_game_content: false,
  world_settings: [],
  id: "",
  // variant_of_name: "",
  use_name: "",
  get_use_name: function (): string {
    throw new Error("Function not implemented.");
  },
  get_homebrewery_string: function (api: APIClass): string {
    throw new Error("Function not implemented.");
  },
  true_name: "",
  source_book_types: [],
  search_ids: [],
  toDBObj: function () {
    throw new Error("Function not implemented.");
  },
  loaded: true,
  
  toLight: function () {
    throw new Error("Function not implemented.");
  },
  copy: function (copyMe: ModelBase, drop_ids?: boolean): void {
    throw new Error("Function not implemented.");
  },
  clone: function (drop_ids?: boolean): ModelBase {
    throw new Error("Function not implemented.");
  },
  tags: [],
  saved_without_api: false,
  get_detail_format: function() { return ""; },
  get_display_format: function() { return ""; },
  description_format: "",
  // detail_format: "",
  display_format: "Plant Speech",
  tag_string: "", free: false
}];

export const LANGUAGE_OPTIONS = LANGUAGES.map(at => {
  const opt: DisablableOption = {
    id: at._id,
    text: at.name
  }
  return opt;
});